import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {Report} from '../../../../models/measure/report';
import {UserService} from '../../../services/user.service';
import {DatePipe} from '@angular/common';
import {DateRange} from '../../../../models/date-range';
import {DateUtils} from '../../../utils/date.utils';
import {UserActionType} from '../../../services/event-tracker/event-tracker.service';

export enum MeasureReportTimeline {
  A_WEEK = 7,
  A_HALF_MONTH = 15,
  A_MONTH = 30,
  TWO_MONTH = 60
}

@Component({
  selector: 'measure-setting',
  templateUrl: './measure-setting.component.html',
  styleUrls: ['./measure-setting.component.scss']
})
export class MeasureSettingComponent {

  @ViewChild('deleteReportWarning')
  deleteReportWarning: AchooPopupComponent;

  @Output()
  selectPeriodEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  deleteReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  allowToEditReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedReport: Report = new Report();
  @Output() periodChange: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  public selectedPeriod: DateRange;
  @Input()
  public measureActionContext;

  public showDateRangePopup = false;

  constructor(private datePipe: DatePipe,
              private modalService: ModalService,
              private userService: UserService) {
  }

  onShowDeleteWarningPopup(e) {
    this.modalService.openInCenter(this.deleteReportWarning);
  }

  onAllowToEditReport(e) {
    this.allowToEditReportEvent.emit(e);
  }

  hideDeleteWarningPopup() {
    this.modalService.close();
  }

  onChangePeriod(selectedPeriod) {
    this.selectPeriodEvent.emit(selectedPeriod);
    this.showDateRangePopup = false;
  }

  deleteReport() {
    this.deleteReportEvent.emit(this.selectedReport);
    this.modalService.close();
  }

  getReportName(selectedReport) {
    return selectedReport ? selectedReport.name : '';
  }

  isPersistedReport() {
    return this.selectedReport && this.selectedReport.id > 0 && !this.selectedReport.is_default_report;
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

  getMeasureContextByAction(actionType) {
    if (actionType === 'delete') {
      const { params } = this.measureActionContext;
      const modifiedParams = Object.assign({}, params, {
        action: UserActionType.DELETE
      });
      return Object.assign({}, this.measureActionContext, {
        params: modifiedParams
      });
    }
    return this.measureActionContext;
  }

  hideDateRangePopup(evt) {
    if (this.showDateRangePopup) {
      this.showDateRangePopup = false;
    }
  }

  onClickDateRangePopup(evt) {
    if (this.showDateRangePopup) {
      this.showDateRangePopup = false;
    } else {
      this.showDateRangePopup = true;
    }
  }

  get formatReportDateRange() {
    if (!this.selectedPeriod) {
      return '';
    }
    const fromDate = this.datePipe.transform(this.selectedPeriod.startDate, 'MMM d');
    const fromDateSuffix = DateUtils.getDateSuffix(this.selectedPeriod.formattedStartDate);
    const endDate = this.selectedPeriod.formattedEndDate;
    const toDate = this.datePipe.transform(this.selectedPeriod.endDate, 'MMM d');
    const toDateSuffix = DateUtils.getDateSuffix(endDate);
    if (this.selectedPeriod.startDate === this.selectedPeriod.endDate) {
      return `${toDate}${toDateSuffix}, ${endDate.getFullYear()}`;
    } else {
      return `${fromDate}${fromDateSuffix} - ${toDate}${toDateSuffix}, ${endDate.getFullYear()}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-setting/measure-setting.component.ts